stimulusApp.register(
  "review-toggle",
  class extends Stimulus.Controller {
    connect() {
      this.body = this.element.querySelector(".reviews-i--body")
      if (this.body) {
        this.content = this.element.querySelector(".reviews-toggle")
        this.link = this.element.querySelector(".reviews-i--read-more")

        document.addEventListener("regwall:unlock", this.#toggleLink.bind(this))

        this.#toggleLink()
      }
    }

    expand() {
      this.body.style.maxHeight = "none"
      this.content.classList.add("reviews-toggle_expanded")
      this.link.remove()
    }

    #toggleLink() {
      let maxBodyHeight = parseInt(getComputedStyle(this.body).maxHeight, 10)

      if (this.content.scrollHeight > maxBodyHeight) {
        this.link.classList.remove("hidden")
      }
    }
  },
)
